/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 渠道系列聚合页
 */
import CryptoJS from 'crypto-js';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { BasesController } from '../bases';
const keyStr = 'usdidx.@.avhjamr';
//import staticJson from './static'
//const str=encrypt();
const staticData = getData();
@BindAll()
export class SeriesProductController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      details: EnumAPI.product_screenList,
      detailsParams: {
        valueGetter: this.detailsValueGetter,
      },
    });
  }
  /**
   * 详情数据 自定义获取 数据重组
   * @param response
   * @returns
   */
  detailsValueGetter(response) {
    lodash.assign(response, {
      // 轮播图
      _SwiperImgs: parsesSwiperImgs(response),
      // 产品列表
      _SeriesList: parsesSeriesList(response),
      //省份地址
      _ProvinceList: staticData.provinceList,
      //服务商列表
      _ServiceProviderList: [],
    });
    return response;
  }
  //获取服务商list
  getSelectServiceProviderList(searchObj) {
    let serviceProviderList = staticData.serviceProviderList;
    let newServiceProviderList = [];
    if (lodash.get(searchObj, 'area')) {
      newServiceProviderList = lodash.filter(
        serviceProviderList,
        function (item) {
          return item.coverageArea.indexOf(searchObj.area) > -1;
        },
      );
    }

    if (lodash.get(searchObj, 'searchKey')) {
      newServiceProviderList = lodash.filter(
        serviceProviderList,
        function (item) {
          return item.corporateName.indexOf(searchObj.searchKey) > -1;
        },
      );
    }

    if (!lodash.get(searchObj, 'area') && !lodash.get(searchObj, 'searchKey')) {
      newServiceProviderList = serviceProviderList;
    }

    this.Details.Model.merge({
      _ServiceProviderList: newServiceProviderList,
    });
  }
}

/**
 * 解析 轮播图
 * @param {*} entity 接口数据
 * @return {*}
 * @memberof ProductController
 */
function parsesSwiperImgs(entity) {
  return lodash.filter(lodash.get(entity, 'fileList', []), [
    'keyword',
    '移动端-Banner图',
  ]);
}

/**
 * 解析 系列产品列表
 * @param {*} entity 接口数据
 * @return {*}
 * @memberof ProductController
 */
function parsesSeriesList(entity) {
  const SeriesList = lodash.map(lodash.get(entity, 'children', []), (item) => {
    const items =
      lodash.find(lodash.get(item, 'fileList', []), (items) => {
        return items.keyword == '列表页-产品图';
      }) || {};
    item.newKeywordValue = items.keywordValue;
    return item;
  });
  return SeriesList;
}
// 解密数据
function getData() {
  const staticStr =
    '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';
  var decrypted = CryptoJS.AES.decrypt(staticStr, keyStr, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  var decryptedStr = CryptoJS.enc.Utf8.stringify(decrypted);
  return JSON.parse(decryptedStr);
}
// function encrypt() {
//   var decrypted = CryptoJS.AES.encrypt(JSON.stringify(staticJson), keyStr, {
//     mode: CryptoJS.mode.ECB,
//     padding: CryptoJS.pad.Pkcs7,
//   });
//   console.log('encrypt*',decrypted)
//   return  decrypted.toString();
// }
